// extracted by mini-css-extract-plugin
export default {"create-account-container":"createAccountPage_create-account-container__ksYUz"};